import Calendar from "../../component/Calendar";
import styles from "./Reservation.module.css";
import { useContext, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AuthContext, AuthContextType } from "../../Auth";
import { baseUrl } from "../../url";
import { Button } from "@mui/material";

export type ReservationType = {
  reservation_id: number;
  application_date: string;
  productname: string;
  color: string;
  left_right: string;
  size: string;
  quantity: number;
  office: string;
  username: string;
  reservation_date: { year: number; month: number; date: number } | "";
  prepared: string;
  order_at: string;
  receiveDate: string;
};

export default function Reservation() {
  const { setAuth } = useContext(AuthContext) as AuthContextType;
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${baseUrl}/checkAuth`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (!data.result) {
          console.log("Not authenticated");
          setAuth({
            username: null,
            isAuthenticated: false,
            office: undefined,
            authority: "user",
          });
          return navigate("/login");
        }
        const response2 = await fetch(`${baseUrl}/getusersdata`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username: data.username }),
        });
        const data2 = await response2.json();
        console.log(
          "Authenticated user:",
          data.username,
          "Office:",
          data2.office,
          "Authority:",
          data2.authority
        );
        setAuth({
          username: data.username,
          isAuthenticated: true,
          office: data2.office,
          authority: data2.authority,
        });
      } catch (error) {
        console.error(error);
      }
    };
    checkAuth();
  }, [navigate, setAuth]);

  return (
    <div className={styles.div}>
      <Link to="/ReservationTable">
        <Button
          variant="contained"
          size="large"
          sx={{
            position: "absolute",
            top: 25,
            left: 250,
            fontSize: 16,
            "@media screen and (max-width:959px)": { top: 60, left: 10 },
          }}
        >
          日付指定で出庫登録
        </Button>
      </Link>
      <h2 className={styles.h2}>出庫予約</h2>
      <p>使用予定日を選択して、製品を選択してください。</p>
      <Calendar />
    </div>
  );
}
